import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { RouterModule } from '@angular/router';
import { ButtonModule } from '@openng/optimus-ui/button';
import { MenuItem } from '@openng/optimus-ui/api';

@Component({
  selector: 'app-plugin-header-nav',
  imports: [RouterModule, ButtonModule],
  changeDetection: ChangeDetectionStrategy.Default,
  templateUrl: './plugin-header-nav.html'
})
export class PluginHeaderNavComponent implements OnInit {
  navItems: MenuItem[] = [];

  ngOnInit() {
    this.navItems = [
      {
        label: 'Plugin Information',
        icon: 'pi pi-fw pi-cog',
        routerLink: '/plugin/dashboard'
      }
    ];
  }
}